export const getForecastDate = (offset = 0) => {
    const date = new Date();
    date.setDate(date.getDate() + offset);
    return new Intl.DateTimeFormat("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date);
  };